/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Basic 1 = Advanced 2 = Business 3 = Enterprise
 */
export type ShieldPlanType = 0 | 1 | 2 | 3;

export const ShieldPlanType = {
  Basic: 0 as ShieldPlanType,
  Advanced: 1 as ShieldPlanType,
  Business: 2 as ShieldPlanType,
  Enterprise: 3 as ShieldPlanType,
};
